import { render, staticRenderFns } from "./GJgrowEventCreateTermSurveyAtBefore.vue?vue&type=template&id=613e7df7&scoped=true&"
import script from "./GJgrowEventCreateTermSurveyAtBefore.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTermSurveyAtBefore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e7df7",
  null
  
)

export default component.exports